import { AlignVAT, ZeroDisplayType } from "@vp/ep-pricing";

export const PRICE_UPDATE_EVENT = "price-update";

export interface Price {
  taxed: number;
  untaxed: number;
}

export interface PriceProperties {
  minimumFractionDigits: number;
  currency: string;
  vatInc: boolean;
  quantity?: number;
  moq?: number;
  hideVatMessage?: boolean;
  hideShippingMessageInVatMessage?: boolean;
  hideMinimumOrderableQuantity?: boolean;
  alwaysShowMOQInfo?: boolean;
  isPriceNegative?: boolean;
  zeroDisplayType?: ZeroDisplayType;
  showComparativeDisplay?: boolean;
  isSetupFeeIncluded?: boolean;
  alignVAT?: AlignVAT;
  hideSetupFee?: boolean;
  isTile?: boolean;
  doesOfferExist?: boolean;
}

export enum PriceDisplayType {
  UnitRangePrice = "unitRangePrice",
  PriceInfo = "priceInfo",
  UnitPriceInfo = "unitPriceInfo",
  FromPrice = "fromPrice",
  UnitFromPrice = "unitFromPrice",
  DifferentialUnitRangePrice = "differentialUnitRangePrice",
  DifferentialPrice = "differentialPrice",
  UnitDifferentialPrice = "unitDifferentialPrice",
  DifferentialPriceForQuantity = "differentialPriceForQuantity",
}

export enum DisplayVariant {
  FROM = "from",
}

export type ProductPricingInput = {
  mpvId?: string;
  productId?: string;
  version?: number;
  selections?: SelectionsWithQuantity;
  alternateSelections?: SelectionsWithQuantity;
  displayVariant?: DisplayVariant;
  requestedPriceDisplayStrategy?: PriceDisplayType;
  hideMinimumOrderableQuantity?: boolean;
  alwaysShowMOQInfo?: boolean; //The prop will enable to show "No minimum quantity" when MOQ=1 if true
};

export type SelectionsWithQuantity = Record<string, string> & { quantity?: string };

export interface Prices {
  baseListPrice?: Price;
  baseDiscountedPrice?: Price;
  totalListPrice?: Price;
  totalDiscountedPrice?: Price;
  unitListPrice?: Price;
  unitDiscountedPrice?: Price;
  unitPriceForMoq?: Price;
  listPriceForMoq?: Price;
  priceDifferenceAtMaximumPrice?: Price;
  discountedPriceDifferenceAtMaximumPrice?: Price;
  priceDifferenceAtMinimumPrice?: Price;
  discountedPriceDifferenceAtMinimumPrice?: Price;
  differentialListPrice?: Price;
  differentialDiscountedPrice?: Price;
  differentialUnitListPrice?: Price;
  differentialUnitDiscountedPrice?: Price;
  setupFeeListPrice?: Price;
  setupFeeDiscountedPrice?: Price;
  highestListPrice?: Price;
  highestDiscountedPrice?: Price;
  lowestListPrice?: Price;
  lowestDiscountedPrice?: Price;
  volumeDiscount?: Price;
}
